module.exports = "p {\n  text-align: justify;\n}"